/* eslint-disable */
import React, { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import { Form, FormElement } from "@progress/kendo-react-form";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { Checkbox } from "@progress/kendo-react-inputs";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";

const MediaCategoryTypeEditForm = (props) => {

    const [mediaCategory, setMediaCategory] = useState([]);

    const [dataItem, setDataItem] = useState({
        Description: props.item.copy ? "Copy of " + props.item.Description : props.item.Description ?? "",
        MediaCategory: props.item.MediaCategorySID ?? {},
        MaterialType: props.item.MaterialType ?? "",
        AutomationType: props.item.AutomationType ?? "",
        CanCreateDeal: props.item.CanCreateDeal ?? false,
        Colors: props.item.Colors ?? { Foreground : "#000000", Background : "#ffffff" },
        Archive: props.item.Archive ?? false
    });

    const lang = useTranslation();


    useEffect(() => {
        loadcombo();
    }, [])


    const loadcombo = async () => {
        var mediaCategoryRes = await API.getDataLookup(ENTITYNAME.MediaCategory);
        setMediaCategory(mediaCategoryRes?.data);
        setDataItem({ ...dataItem, MediaCategory: mediaCategoryRes.data?.find(obj => obj.SID == props.item?.MediaCategorySID) })
    }

    const isValid = () => {
        if (!dataItem.MediaCategory || Object.keys(dataItem.MediaCategory).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_category_error_message });
            return false;
        }
        if (dataItem.Description === '' || dataItem.Description === undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false;
        }
        return true;
    }


    const handleSubmit = async () => {

        if (isValid()) {
            const saveData = {
                SID: props.item.SID ?? 0,
                Description: dataItem.Description ?? '',
                MediaCategorySID: dataItem.MediaCategory.SID,
                MaterialType: dataItem.MaterialType,
                CanCreateDeal: dataItem.CanCreateDeal ?? false,
                Colors: dataItem.Colors,
                Archive: dataItem.Archive ?? false,
                AutomationType: dataItem.AutomationType
            }
            var res = await API.saveData(ENTITYNAME.MediaCategoryType, saveData);
            if (res.success) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.MEDIACATEGORYTYPE, data: res.data, message: res.message };
                API.SaveLogs(logData);
                props.refresh();
                props.cancelEdit();
                utility.deleteLocalStorageItem(ENTITYNAME.MediaCategoryType);
                return;
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        }
    }

    const onChange = (e) => {
        console.log(e.target.value)
        if(e.target.name == "Foreground" || e.target.name == "Background") {
            setDataItem({ ...dataItem, Colors : { ...dataItem.Colors, [e.target.name]: e.target.value }});
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    return (
        <>
            <BossDialog
                title={props.item.SID > 0 ? props.item.Description : lang.media_category_type_label}
                onClose={props.cancelEdit}
                width={"600px"}
            >
                <Form
                    render={() => (
                        <FormElement>
                            <div className="row">
                                <div className="col-12">

                                    <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={props.cancelEdit} />
                                    <div className="row mt-2">
                                        <div className="col-6">
                                            <label>{lang.media_category_label} *</label>
                                            <DropDownList
                                                data={mediaCategory}
                                                name="MediaCategory"
                                                textField="Description"
                                                dataItemKey="_id"
                                                value={dataItem.MediaCategory}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>{lang.description_label} *</label>
                                            <input
                                                name={"Description"}
                                                type="text"
                                                className="form-control form-control-sm"
                                                onChange={onChange}
                                                value={dataItem.Description}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-6">
                                            <label>{lang.material_type_label}</label>
                                            <input
                                                name={"MaterialType"}
                                                type="text"
                                                className="form-control form-control-sm"
                                                onChange={onChange}
                                                value={dataItem.MaterialType}
                                            />
                                        </div>
                                        <div className="col-6">
                                            <label>{lang.automation_type_label}</label>
                                            <input
                                                name={"AutomationType"}
                                                type="text"
                                                className="form-control form-control-sm"
                                                onChange={onChange}
                                                value={dataItem.AutomationType}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div style={{ padding: '0px 2px 0px 16px' }} className="col-4 form-group">
                                            <label htmlFor="">{lang.foreground_color_label}</label>
                                            <input type="text" className="form-control form-control-sm" name="Foreground" value={dataItem.Colors.Foreground} onChange={onChange} />
                                        </div>
                                        <div style={{ padding: '20px 16px 0px 2px' }} className="col-2 form-group">
                                            <input type="color" className="form-control form-control-sm" name="Foreground" value={dataItem.Colors.Foreground} onChange={onChange} title={lang.text_color_label} />
                                        </div>
                                        <div style={{ padding: '0px 2px 0px 16px' }} className="col-4 form-group">
                                            <label htmlFor="">{lang.background_color_label}</label>
                                            <input type="text" className="form-control form-control-sm" name="Background" value={dataItem.Colors.Background} onChange={onChange} />
                                        </div>
                                        <div style={{ padding: '20px 16px 0px 2px' }} className="col-2 form-group">
                                            <input type="color" className="form-control form-control-sm" name="Background" value={dataItem.Colors.Background} onChange={onChange} title={lang.text_color_label} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col mt-3">
                                            <Checkbox
                                                name={"CanCreateDeal"}
                                                style={{ marginLeft: "5px", marginBottom: "20px", borderColor: "black" }}
                                                value={dataItem.CanCreateDeal}
                                                onChange={onChange}
                                            />
                                            <label className="pl-1">{lang.cancreatedeal_label}</label>

                                        </div>
                                        <div className="col mt-3">
                                            <Checkbox
                                                name={"Archive"}
                                                style={{ marginLeft: "5px", marginBottom: "20px", borderColor: "black" }}
                                                value={dataItem.Archive}
                                                onChange={onChange}
                                            />
                                            <label className="pl-1">{lang.archive}</label>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </FormElement>
                    )}
                />
            </BossDialog>
        </>)
};

export default MediaCategoryTypeEditForm;